import { createFileRoute } from '@tanstack/react-router';

import { requireAuth } from '@/app/lib/auth-guard';
import { MakePaymentPage } from '@/billing/pages/make-payment';

export const Route = createFileRoute('/billing/make-payment')({
  beforeLoad: async (ctx) => {
    await requireAuth(ctx);
  },
  component: MakePaymentRoute,
  staticData: {
    headerSection: 'billing'
  }
});

function MakePaymentRoute() {
  return <MakePaymentPage/>;
}
